// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"18d8a752","369":"b1bd49a5","498":"21260899","586":"ca6951e8","652":"ebb1c0b0","750":"0ab74d81","796":"6bd3fdd5","797":"6bf4c864","851":"407db12c","864":"299ed21a"}[chunkId] + ".chunk.js";
};